'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';

var ResultHeader = /*#__PURE__*/function (_Component) {
  _inherits(ResultHeader, _Component);

  function ResultHeader() {
    _classCallCheck(this, ResultHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResultHeader).apply(this, arguments));
  }

  _createClass(ResultHeader, [{
    key: "render",
    value: function render() {
      var localizedTextKey = this.props.localizedTextKey;
      return /*#__PURE__*/_jsx("div", {
        className: "result-header",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: localizedTextKey + ".header"
        })
      });
    }
  }]);

  return ResultHeader;
}(Component);

ResultHeader.propTypes = {
  localizedTextKey: PropTypes.string
};
export { ResultHeader as default };